export const PDF_STYLES = {
    headerFontSize: 12,
    footerFontSize: 9,
    defaultFontSize: 8,
    headerBg: '#D3D3D3',
    groupBg: '#BEDFE6',
    negativeColorArgb: 'FFEF0000',
    negativeHex: '#f70505',
    headerTextColor: '#000000',
    leftMargin: 4,
    rightMargin: 4,
    firstPageHeaderHeight: 40,
    otherPageHeaderHeight: 20,
};